// Any element with an id or class that starts with this prefix is used by Product for usage tracking,
// e.g. through Pendo. When removing an element with such id or class, ask Product if they
// still need to track usage/clicks/visits and add this id/class name to an element
// that can fulfill the same tracking purpose.
export const USAGE_TRACKING_PREFIX = 'usage-tracking';
